import Vue, { PropType, Component } from 'vue';

// Creation modules
import loginController from '@/scripts/libs/login/controller';
import User from '@/scripts/libs/login/User';
import viddsee from '@/scripts/viddsee';

// Profiles Componnets
import ProfilePictureInitial from '@/scripts/Components/Molecules/ProfilePictureInitial.vue';
import ProfileSection from '@/scripts/Components/Organisms/Profile/ProfileSection/index.vue';
import ProfileActions from '@/scripts/Components/Organisms/Profile/ProfileActions.vue';
import ProfilePointsSection from '@/scripts/Components/Organisms/Profile/ProfilePointsSection/index.vue';

import AlertBanner from '@/scripts/Components/Molecules/AlertBanner.vue';
import truncate from '@/scripts/Components/Utilities/truncate.vue';

// Vue utilities
import VueScrollTo from 'vue-scrollto';
import { UserResponseV2 } from '@/scripts/models/UserResponse';
import { UserInfoCompat } from '@/scripts/libs/login/userResponseProcessor';

const URL_NAME_EXTRACTION_REGEX = /\/u\/([^/]*)/;

interface ComponentData {
  user: null | UserInfoCompat;
  isVideoSectionReady: boolean;
  profilePermissions: {
    isOwner: boolean;
    viewAsOther: boolean;
  };
}

interface GetUserData {
  bio: string;
  profileImage: string;
  fullname: string;
  tags: Array<string>;
  level: string;
}

class VSProfile {
  init(): Component {
    return Vue.extend({
      i18n: {
        en: {
          'login-reason': 'Please sign up to create and customise you profile on Viddsee.',
        },
        id: {
          'login-reason': 'Daftarkan diri untuk membuat dan menyesuaikan profilmu di Viddsee.',
        },
        zh: {
          'login-reason': '即刻註冊帳號即可創建和客制您的Viddsee帳戶。',
        },
      },

      components: {
        ProfilePictureInitial,
        ProfileSection,
        ProfileActions,
        ProfilePointsSection,

        AlertBanner,
        truncate,
      },
      props: {
        ssr: {
          type: Boolean,
          default: false,
        },
        error: {
          type: Boolean,
          default: false,
        },
        rawUser: {
          type: Object as PropType<null | UserResponseV2>,
          default: (): null => null,
        },
      },
      data(): ComponentData {
        return {
          // Page data
          user: null,

          isVideoSectionReady: false,
          profilePermissions: {
            isOwner: !this.ssr,
            viewAsOther: false,
          },
        };
      },
      computed: {
        getUser(): GetUserData {
          if (this.user == null) {
            return {
              bio: '',
              profileImage: '',
              fullname: '',
              tags: [],
              level: '',
            };
          }
          return {
            bio: (this.user.profile.bio || '').replace(/\n/g, '<br>'),
            profileImage: this.user.profile.profileImage(800),
            fullname: `${this.user.profile.firstName} ${this.user.profile.lastName}`.trim(),
            tags: this.user.profile.hasFilms ? this.user.profile.labels : [], // TODO: #377 Retrieve this information from the server?
            level: this.user.points.level.name,
          };
        },
      },
      created() {
      // Return a user object
        if (this.ssr) {
          this.user = User.getProcessedResponse(this.rawUser);
          // Compute viewAsOther permission here
          loginController.getUser()
            .then((user) => {
              if (!user) return;
              const [, urlString] = location.pathname.match(URL_NAME_EXTRACTION_REGEX) || [];
              const hasMatchingPidOrVanity = (`${user.pid}` === urlString) || (`${user.profile.vanity}` === urlString);

              this.profilePermissions.viewAsOther = hasMatchingPidOrVanity;
            })
            .then(() => {
              this.isVideoSectionReady = true;
            });
        } else {
          loginController.getUser()
            .then((user) => {
              this.user = user;
              if (!user) {
                viddsee.ui.modal.register.open({
                  isPersistent: true,
                  loginReason: this.$t('login-reason'),
                });
              }
            })
            .then(() => {
              this.isVideoSectionReady = true;
            });
        }
      },
      methods: {
        closeBanner(): void {
          VueScrollTo.scrollTo(
            this.$refs.profileBar as HTMLElement,
          );
        },
      },
    });
  }
}

export default new VSProfile();
